module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAZklEQVR4AWOgE9gMR99vMqChx4oCcDRQGl6eYTy9he3KHtaXZxmJ0jC3iWdOhOD0UMGlPVxEaWgtFa3MMchPsVjaLUSUhmWTOPNyVUoLNPYt4iDW07vmsB1czPLjFumhRH8NgxIAAEtpvBDl3VdPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MD.png
// module id = 1202
// module chunks = 0